var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinicalDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8498 28.5763C34.8186 27.3838 35.699 26.0715 36.4173 24.7297C39.4834 19.0023 36.5633 13.1072 31.5296 9.71371C30.2836 8.87359 28.8392 8.09741 27.4101 7.60855C26.0656 7.14851 24.5217 6.80615 23.0944 6.7605C17.1207 6.56916 11.8403 9.60655 8.42902 14.3258C5.11465 18.911 4.70521 26.1866 7.16697 31.2003C7.98357 32.8635 9.49536 34.8372 11.1143 35.8198C12.7704 36.8245 14.8048 37.1766 16.7208 37.2579C22.8936 37.5195 29.5578 33.5947 33.4364 29.0716C33.5757 28.9091 33.7137 28.7438 33.8498 28.5763Z",
    fill: "#EEF0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4177 8.13477V15.2149C23.4177 15.884 23.9601 16.4264 24.6292 16.4264H31.7093M23.4177 8.13477H24.5742C24.8955 8.13477 25.2036 8.26241 25.4308 8.48962L31.3545 14.4132C31.5817 14.6404 31.7093 14.9486 31.7093 15.2699V16.4264M23.4177 8.13477L18.1056 8.13486L12.1227 8.13478C11.4536 8.13477 10.9111 8.6772 10.9111 9.34632V29.693M31.7093 16.4264V32.1808C31.7093 32.8499 31.1669 33.3924 30.4978 33.3924H12.1227C11.4536 33.3924 10.9111 32.8499 10.9111 32.1808V28.8639",
    stroke: "#1E3269",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0234 27.1348H20.8603",
    stroke: "#38476E",
    strokeWidth: 1.4875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0234 23.6816H24.937",
    stroke: "#38476E",
    strokeWidth: 1.4875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0234 19.8809H24.937",
    stroke: "#38476E",
    strokeWidth: 1.4875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalDocuments);
export default __webpack_public_path__ + "static/media/Clinical-Documents.383208be00bff10dce268c40636b793a.svg";
export { ForwardRef as ReactComponent };